import React, {
  useCallback,
  useEffect,
  useRef,
  useState,
  useContext,
} from "react";
import Cookies from "js-cookie";
import SearchSelectElement from "../../form/SearchSelectElement";
import InputElement from "../../form/InputElement";
import stylesRequestData from "../../../components/UnifiedTaxDeclaration/UnifiedTaxDeclarationRequestData/index.module.css";
import {
  getMapPoliceStationsByGovernorate,
  getMapStreetsByPoliceStation,
  getMapCitiesByGovernorate,
  getMapDistrictsByCity,
  getMapMogawrasByDistrict,
  getMapGovernorates,
  getSettlementsByGovID,
} from "../../../adapters/apis/lookups/lookups";
import UnifiedTaxDeclarationContext from "../../../contexts/UnifiedTaxDeclarationProvider";
import { get } from "../../../adapters/xhr/api";
import { refresh } from "../../../adapters/apis/auth/auth";
import { useSearchParams } from "react-router-dom";
import InfoPopover from "../../form/InfoPopover";
import infoIconSvg from "../../../assets/img/Icon-metro-info.svg";
import styles from "./CommonAddressMap.module.css";

const mapConfig = {
  backgroundServiceURL: "http://{s}.google.com/vt/lyrs=y&x={x}&y={y}&z={z}",
  backgroundServiceType: "google_sat",
  apiBackendURL: process.env.REACT_APP_BASE_URL + "api",
  tokenApiBackendURL: process.env.REACT_APP_BASE_URL + "api",
};

function IframeMapComponent() {
  const emcRef = useRef(null);
  const mapInitializedRef = useRef(false);

  const [searchParams, setSearchParams] = useSearchParams();
  const urbanParam = searchParams.get("urban");
  const searchUsingParam =
    searchParams.get("search-using") || searchParams.get("search_using");
  const latParam = searchParams.get("lat");
  const lngParam = searchParams.get("lng");

  const [suggestions, setSuggestions] = useState([
    { place_id: 1, description: 1 },
  ]);

  const unifiedTaxDeclarationContext =
    useContext(UnifiedTaxDeclarationContext) || {};

  const {
    declarationRequest: contextDeclarationRequest,
    setDeclarationRequest: contextSetDeclarationRequest,
    isUnitInSameBuilding = false,
    govs: contextGovs,
    setGovs: contextSetGovs,
  } = unifiedTaxDeclarationContext;

  const [localDeclarationRequest, setLocalDeclarationRequest] = useState({
    viewMode: false,
    isUnitViewMode: false,
    unit: {
      new_urban_communities_authority: 0,
    },
  });
  const [localGovs, setLocalGovs] = useState([]);

  const declarationRequest =
    contextDeclarationRequest ?? localDeclarationRequest;

  const activeBuildingProfile = declarationRequest?.unit?.buildingProfile;
  const govs = contextGovs ?? localGovs;

  const resolvedUnit = searchParams.get("unit");
  const resolvedPropertyTypeId = searchParams.get("property_type_id");
  const resolvedId = searchParams.get("id");
  const tokenParam = searchParams.get("token");
  const refreshTokenParam = searchParams.get("refresh_token");
  const minute = 1000 * 60;

  useEffect(() => {
    if (tokenParam) {
      Cookies.set("auth-token", tokenParam);
    }
    if (refreshTokenParam) {
      Cookies.set("refresh-token", refreshTokenParam);
    }
  }, []);

  useEffect(() => {
    const interval = setInterval(function () {
      const refresh_token = Cookies.get("refresh-token");
      if (refresh_token) {
        refresh({ refresh_token })
          .then((response) => {
            const is_login = parseInt(response.data.isAuth);
            console.log("Token refresh response:", response.data);
            if (is_login === 1) {
              console.log("Token refreshed successfully");
              Cookies.set("auth-token", response?.data?.access_token);
              Cookies.set("refresh-token", response?.data?.refresh_token);
              Cookies.set("user-name", response?.data?.first_name);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    }, process.env.REACT_APP_REFRESH_TOKEN_MINS * minute);

    return () => clearInterval(interval);
  }, []);

  const buildFullAddressDisplayViewMode = (profile) => {
    if (!profile) return "";
    const addr = profile.address || {};

    const fields = [
      ["المحافظة", addr?.goveronrate],
      ["المدينة", addr?.city],
      ["قسم/مركز الشرطة", addr?.policestation],
      ["الشياخة", addr?.neighborhood],
      ["الحي/المنطقة", addr?.district],
      ["المجاورة", addr?.mogawra],
      ["القرية", addr?.village],
      ["الشارع", addr?.street],
      ["التجمع السكني", addr?.settlement],
      ["رقم العقار", profile.number],
    ];

    return fields
      .map(([label, value]) => [label, normalizeProfileFieldValue(value)])
      .filter(([_, value]) => value)
      .map(([label, value], index, arr) => (
        <span key={label}>
          <strong>{label}:</strong> {value}
          {index < arr.length - 1 && "، "}
        </span>
      ));
  };
  const setDeclarationRequest = useCallback(
    (updater) => {
      if (typeof contextSetDeclarationRequest === "function") {
        contextSetDeclarationRequest(updater);
        return;
      }

      setLocalDeclarationRequest((prev) =>
        typeof updater === "function" ? updater(prev) : updater,
      );
    },
    [contextSetDeclarationRequest],
  );

  const setGovs = useCallback(
    (value) => {
      if (typeof contextSetGovs === "function") {
        contextSetGovs(value);
        return;
      }

      setLocalGovs(value);
    },
    [contextSetGovs],
  );

  // const triggerIframeClick = () => {
  //   if (!emcRef.current) return;

  //   emcRef.current.dispatchEvent(
  //     new MouseEvent("click", {
  //       bubbles: true,
  //       cancelable: true,
  //       view: window,
  //     }),
  //   );
  // };

  useEffect(() => {
    const nextSearchParams = new URLSearchParams(searchParams);
    let hasChanges = false;

    if (resolvedUnit && nextSearchParams.get("unit") !== String(resolvedUnit)) {
      nextSearchParams.set("unit", String(resolvedUnit));
      hasChanges = true;
    }

    if (
      (resolvedPropertyTypeId || resolvedPropertyTypeId === 0) &&
      nextSearchParams.get("property_type_id") !==
        String(resolvedPropertyTypeId)
    ) {
      nextSearchParams.set("property_type_id", String(resolvedPropertyTypeId));
      hasChanges = true;
    }

    if (
      (resolvedId || resolvedId === 0) &&
      nextSearchParams.get("id") !== String(resolvedId)
    ) {
      nextSearchParams.set("id", String(resolvedId));
      hasChanges = true;
    }

    if (hasChanges) {
      setSearchParams(nextSearchParams, { replace: true });
    }
  }, [
    resolvedUnit,
    resolvedPropertyTypeId,
    resolvedId,
    searchParams,
    setSearchParams,
  ]);

  useEffect(() => {
    if (!resolvedUnit || !resolvedPropertyTypeId || !resolvedId) return;

    const fetchMapComponentProfile = async () => {
      try {
        const queryParams = new URLSearchParams({
          id: String(resolvedId),
          property_type_id: String(resolvedPropertyTypeId),
          unit: String(resolvedUnit),
        });

        const response = await get(
          `api/declaration-system/public/map-component-profile?${queryParams.toString()}`,
          {},
          false,
        );

        const responseData = response?.data?.data || response?.data;
        if (!responseData) return;

        const mapProfile = responseData?.buildingProfile;

        setDeclarationRequest((prev) => ({
          ...prev,
          unit: {
            ...prev?.unit,
            buildingProfile: mapProfile,
          },
        }));
      } catch (error) {
        console.error("Failed to load map component profile", error);
      }
    };

    fetchMapComponentProfile();
  }, [resolvedUnit, resolvedPropertyTypeId, resolvedId, setDeclarationRequest]);

  const [policeStations, setPoliceStations] = useState([]);
  const [streets, setStreets] = useState([]);
  const [cities, setCities] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [mogawras, setMogawras] = useState([]);
  const [settlements, setSettlements] = useState([]);
  const [unitMapError, setUnitMapError] = useState("");

  const [error_new_user] = useState({
    governorate_id: "",
    city_id: "",
    district_id: "",
    mogawra_id: "",
    police_station_id: "",
    street_id: "",
    settlement_id: "",
    manual_search_address: "",
  });

  const generateOptions = (data) =>
    data?.map(({ id, name }) => ({ value: id.toString(), label: name }));

  const parseSearchMode = (value) => {
    const parsedValue = Number(value);
    return [1, 2, 3].includes(parsedValue) ? parsedValue : null;
  };

  const selectedSearchMode =
    parseSearchMode(declarationRequest?.unit?.filter_search_type_id) ||
    parseSearchMode(searchUsingParam) ||
    (urbanParam === "1" ? 2 : 1);

  const mapZoomToLayer = (mapLayerCode) => {
    if (!emcRef.current || !mapInitializedRef.current) return;
    const event = new CustomEvent("zoomToLayer", {
      detail: { MapLayerCode: mapLayerCode },
    });
    emcRef?.current?.dispatchEvent(event);
  };

  const mapZoomToFeature = (mapLayerCode, featureId) => {
    if (!emcRef.current || !mapInitializedRef.current) return;
    if (!featureId && featureId !== 0) return;

    const parsed = Number(featureId);
    if (!Number.isFinite(parsed) || parsed <= 0) return;

    const event = new CustomEvent("zoomToFeature", {
      detail: { MapLayerCode: mapLayerCode, FeatureID: parsed },
    });
    emcRef?.current?.dispatchEvent(event);
  };

  const handleChangeGoogleSearch = async (pc, c, key, value) => {
    handleChangeDeclerationUnit(pc, c, key, value);
    const response = await get(
      `api/declaration-system/geo/search?q=${value}`,
      {},
      false,
    );

    setSuggestions(response?.data?.data || []);
  };

  useEffect(() => {
    if (!emcRef.current) return;

    const mapElement = emcRef.current;

    const onDoubleClick = () => {
      const listener = (e) => {
        if (!e || !e.detail) {
          console.warn("IdentifiedFeatureData fired with null detail");
          return;
        }

        const transformedBuildingProfile = transformObject(e.detail);

        if (!transformedBuildingProfile) return;

        if (isEmptyProfile(transformedBuildingProfile)) {
          setUnitMapError(
            "هذا العقار غير متاح حالياً، لحين تحديث بيانات الخريطة برجاء اختيار أقرب عقار لسهولة تحديد الموقع",
          );

          setDeclarationRequest((prev) => ({
            ...prev,
            unit: {
              ...prev?.unit,
              buildingProfile: null,
            },
          }));
          return;
        }

        setUnitMapError("");

        setDeclarationRequest((prev) => ({
          ...prev,
          unit: {
            ...prev?.unit,
            buildingProfile: transformedBuildingProfile,
          },
        }));

        const coords =
          transformedBuildingProfile?.geometry?.geojson
            ?.coordinates?.[0]?.[0]?.[0];

        if (Array.isArray(coords) && coords.length >= 2) {
          const [long, lat] = coords;

          mapElement.dispatchEvent(
            new CustomEvent("zoomToLatLong", {
              detail: { Lat: lat, Long: long, ZoomLevel: 20 },
            }),
          );
        }
      };

      mapElement.addEventListener("IdentifiedFeatureData", listener, {
        once: true,
      });
    };

    mapElement.addEventListener("dblclick", onDoubleClick);

    return () => {
      mapElement.removeEventListener("dblclick", onDoubleClick);
    };
  }, [setDeclarationRequest]);

  const handleChangeDeclerationUnit = (pc, c, key, value) => {
    setDeclarationRequest((prev) => ({
      ...prev,
      unit: {
        ...prev.unit,
        [key]: value,
      },
    }));
  };

  const hasValidBuildingProfile =
    activeBuildingProfile &&
    Object.keys(activeBuildingProfile).length > 0 &&
    activeBuildingProfile.address;

  const addressRef = useRef(null);

  const resetFromGovernorate = () => {
    setPoliceStations([]);
    setStreets([]);
    setCities([]);
    setDistricts([]);
    setMogawras([]);
    setSettlements([]);
    setDeclarationRequest((prev) => ({
      ...prev,
      unit: {
        ...prev.unit,
        police_station_id: null,
        street_id: null,
        city_id: null,
        district_id: null,
        mogawra_id: null,
        settlement_id: null,
      },
    }));
  };

  const resetFromPoliceStation = () => {
    setStreets([]);
    setDeclarationRequest((prev) => ({
      ...prev,
      unit: {
        ...prev.unit,
        street_id: null,
      },
    }));
  };

  const resetFromCity = () => {
    setDistricts([]);
    setMogawras([]);
    setDeclarationRequest((prev) => ({
      ...prev,
      unit: {
        ...prev.unit,
        district_id: null,
        mogawra_id: null,
      },
    }));
  };

  const resetFromDistrict = () => {
    setMogawras([]);
    setDeclarationRequest((prev) => ({
      ...prev,
      unit: {
        ...prev.unit,
        mogawra_id: null,
      },
    }));
  };

  const handleChangeGov = async (pc, c, key, value) => {
    resetFromGovernorate();
    handleChangeDeclerationUnit(pc, c, key, value);

    if (!value) return;

    try {
      if (selectedSearchMode === 2) {
        const response = await getMapCitiesByGovernorate(value);
        setCities(response?.data?.data || []);
      }

      if (selectedSearchMode === 1) {
        const response = await getMapPoliceStationsByGovernorate(value);
        setPoliceStations(response?.data?.data || []);
      }

      const settlementResponse = await getSettlementsByGovID(value);
      setSettlements(settlementResponse?.data?.data || []);

      mapZoomToFeature(1, value);
    } catch (error) {
      setCities([]);
      setPoliceStations([]);
      setSettlements([]);
      console.error("Failed to load map governorate dependencies", error);
    }
  };

  const handleChangeCity = async (pc, c, key, value) => {
    resetFromCity();
    handleChangeDeclerationUnit(pc, c, key, value);

    if (!value) return;

    try {
      const response = await getMapDistrictsByCity(value);
      setDistricts(response?.data?.data || []);
      mapZoomToFeature(5, value);
    } catch (error) {
      setDistricts([]);
      console.error("Failed to load map districts", error);
    }
  };

  const handleChangeDistrict = async (pc, c, key, value) => {
    resetFromDistrict();
    handleChangeDeclerationUnit(pc, c, key, value);

    if (!value) return;

    try {
      const response = await getMapMogawrasByDistrict(value);
      setMogawras(response?.data?.data || []);
      mapZoomToFeature(6, value);
    } catch (error) {
      setMogawras([]);
      console.error("Failed to load map mogawras", error);
    }
  };

  const handleChangeMogawra = (pc, c, key, value) => {
    handleChangeDeclerationUnit(pc, c, key, value);
    mapZoomToFeature(7, value);
  };

  const handleChangePoliceStation = async (pc, c, key, value) => {
    resetFromPoliceStation();
    handleChangeDeclerationUnit(pc, c, key, value);

    if (!value) return;

    try {
      const response = await getMapStreetsByPoliceStation(value);
      setStreets(response?.data?.data || []);
      mapZoomToFeature(2, value);
    } catch (error) {
      setStreets([]);
      console.error("Failed to load map streets", error);
    }
  };

  const handleChangeStreet = (pc, c, key, value) => {
    handleChangeDeclerationUnit(pc, c, key, value);
    mapZoomToFeature(4, value);
  };

  const handleChangeSettlement = (pc, c, key, value) => {
    handleChangeDeclerationUnit(pc, c, key, value);
    mapZoomToFeature(8, value);
  };

  const buildAddressText = (profile) => {
    if (!profile || !profile.address) return "";

    const addressParts = [
      profile.address?.goveronrate,
      profile.address?.city,
      profile.address?.district,
      profile.address?.mogawra,
      profile.address?.street,
      profile.address?.settlement,
      profile.number,
    ].filter(Boolean);

    return addressParts.join("، ");
  };

  useEffect(() => {
    if (hasValidBuildingProfile && addressRef.current) {
      addressRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, [hasValidBuildingProfile]);

  useEffect(() => {
    const loadMapAndGovernorates = async () => {
      if (emcRef.current && !mapInitializedRef.current) {
        const initializeEvent = new CustomEvent("initializeMap", {
          detail: {
            BackgroundServiceURL: mapConfig.backgroundServiceURL,
            BackgroundServiceType: mapConfig.backgroundServiceType,
            APIBackendURL: mapConfig.apiBackendURL,
            TokenApiBackendURL: mapConfig.tokenApiBackendURL,
          },
        });

        emcRef?.current?.dispatchEvent(initializeEvent);
        mapInitializedRef.current = true;

        // if (!latParam || !lngParam) {
        //   mapZoomToLayer(1);
        // }
      }

      try {
        const response = await getMapGovernorates();
        setGovs(response?.data?.data || []);

        // setTimeout(() => {
        //   triggerIframeClick();
        // }, 200);
      } catch (error) {
        setGovs([]);
        console.error("Failed to load map governorates", error);
      }
    };

    loadMapAndGovernorates();
  }, [latParam, lngParam, setGovs]);

  const zoomToLatLong = (lat, lng, zoomLevel = 18) => {
    if (!emcRef.current || !mapInitializedRef.current) return;

    const customZoomToLatLongEvent = new CustomEvent("zoomToLatLong", {
      detail: {
        Lat: Number(lat),
        Long: Number(lng),
        ZoomLevel: zoomLevel,
      },
    });

    emcRef.current.dispatchEvent(customZoomToLatLongEvent);
  };

  useEffect(() => {
    if (!latParam || !lngParam) return;
    if (!mapInitializedRef.current) return;

    const lat = parseFloat(latParam);
    const lng = parseFloat(lngParam);

    if (!Number.isFinite(lat) || !Number.isFinite(lng)) return;

    zoomToLatLong(lat, lng, 18);
  }, [latParam, lngParam]);

  useEffect(() => {
    const modeFromQuery = parseSearchMode(searchUsingParam);
    const fallbackModeFromUrban =
      urbanParam === null ? null : urbanParam === "1" ? 2 : 1;
    const nextMode = modeFromQuery || fallbackModeFromUrban;

    if (!nextMode) return;

    const currentMode = parseSearchMode(
      declarationRequest?.unit?.filter_search_type_id,
    );

    if (currentMode === nextMode) return;

    setDeclarationRequest((prev) => ({
      ...prev,
      unit: {
        ...prev.unit,
        filter_search_type_id: nextMode,
        new_urban_communities_authority: nextMode === 2 ? 1 : 0,
      },
    }));
  }, [
    declarationRequest?.unit?.filter_search_type_id,
    searchUsingParam,
    urbanParam,
    setDeclarationRequest,
  ]);

  useEffect(() => {
    if (selectedSearchMode !== 3) return;

    const profile = declarationRequest?.unit?.buildingProfile;
    const formattedAddress = buildAddressText(profile);

    if (!formattedAddress || declarationRequest?.unit?.manual_search_address) {
      return;
    }

    setDeclarationRequest((prev) => ({
      ...prev,
      unit: {
        ...prev.unit,
        manual_search_address: formattedAddress,
      },
    }));
  }, [
    declarationRequest?.unit?.buildingProfile,
    declarationRequest?.unit?.manual_search_address,
    selectedSearchMode,
    setDeclarationRequest,
  ]);

  const normalizeProfileFieldValue = (value) => {
    if (!value) return null;

    const cleaned = String(value).split("|")[0].trim();
    return cleaned && cleaned !== "لا يوجد" ? cleaned : null;
  };

  const transformObject = (obj) => {
    const address = obj?.address || {};
    const newAddress = {};
    const addressIds = {};

    for (const [key, value] of Object.entries(address)) {
      if (value === "|") {
        newAddress[key] = null;
        addressIds[`${key}_id`] = null;
      } else if (typeof value === "string" && value.includes("|")) {
        const [text, id] = value.split("|");
        newAddress[key] = text || null;
        addressIds[`${key}_id`] = id || null;
      } else {
        newAddress[key] = value;
        addressIds[`${key}_id`] = null;
      }
    }

    return {
      ...obj,
      address: newAddress,
      address_ids: addressIds,
    };
  };

  const isEmptyProfile = (profile) => {
    if (!profile) return true;

    const topLevelEmpty =
      !profile.renin &&
      !profile.number &&
      !profile.name &&
      !profile.area_m2 &&
      !profile.type;

    const address = profile.address || {};
    const addressEmpty = Object.values(address).every(
      (val) => val === null || val === "|",
    );

    const geometryEmpty = !profile.geometry?.geojson;

    return topLevelEmpty && addressEmpty && geometryEmpty;
  };

  return (
    <div className={styles.iframeRoot}>
      <div className="row">
        <div className="w-100"></div>
        {selectedSearchMode === 2 ? (
          <>
            <div className="col-lg-4 col-sm-6">
              <SearchSelectElement
                mb4="mb-4"
                labelHtmlFor="governorate_id"
                labelClassName={`form-label ${stylesRequestData["form-label"]}`}
                labelText="المحافظة"
                selectClassName={`${stylesRequestData["form-select"]} form-select`}
                selectID="governorate_id"
                inputId="governorate_id_input"
                name="governorate_id"
                options={generateOptions(govs)}
                default="أختار المحافظة.."
                pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                pText={error_new_user.governorate_id}
                value={parseInt(declarationRequest?.unit?.governorate_id)}
                // key={parseInt(declarationRequest?.unit?.governorate_id)}
                onChange={handleChangeGov}
                isClearable={true}
                disabled={
                  declarationRequest?.viewMode ||
                  declarationRequest?.isUnitViewMode ||
                  isUnitInSameBuilding
                }
              />
            </div>
            <div className="col-lg-4 col-sm-6">
              <SearchSelectElement
                mb4="mb-4"
                labelHtmlFor="city_id"
                labelClassName={`form-label ${stylesRequestData["form-label"]}`}
                labelText="المدينة"
                selectClassName={`${stylesRequestData["form-select"]} form-select`}
                selectID="المدينة"
                inputId="city_id_input"
                name="city_id"
                options={generateOptions(cities)}
                default="أختار المدينة.."
                pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                pText={error_new_user.city_id}
                value={parseInt(declarationRequest?.unit?.city_id)}
                onChange={handleChangeCity}
                isClearable={true}
                disabled={
                  declarationRequest?.viewMode ||
                  declarationRequest?.isUnitViewMode ||
                  isUnitInSameBuilding
                }
              />
            </div>
            <div className="col-lg-4 col-sm-6">
              <SearchSelectElement
                mb4="mb-4"
                labelHtmlFor="district_id"
                labelClassName={`form-label ${stylesRequestData["form-label"]}`}
                labelText="الحي/ المنطقة"
                selectClassName={`${stylesRequestData["form-select"]} form-select`}
                selectID="الحي/ المنطقة"
                inputId="district_id_input"
                name="district_id"
                options={generateOptions(districts)}
                default="أختار الحي/ المنطقة.."
                pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                pText={error_new_user.district_id}
                value={parseInt(declarationRequest?.unit?.district_id)}
                onChange={handleChangeDistrict}
                isClearable={true}
                disabled={
                  declarationRequest?.viewMode ||
                  declarationRequest?.isUnitViewMode ||
                  isUnitInSameBuilding
                }
              />
            </div>
            <div className="col-lg-4 col-sm-6">
              <SearchSelectElement
                mb4="mb-4"
                labelHtmlFor="mogawra_id"
                labelClassName={`form-label ${stylesRequestData["form-label"]}`}
                labelText="المجاورة"
                selectClassName={`${stylesRequestData["form-select"]} form-select`}
                selectID="المجاورة"
                inputId="mogawra_id_input"
                name="mogawra_id"
                options={generateOptions(mogawras)}
                default="أختار المجاورة.."
                pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                pText={error_new_user.mogawra_id}
                value={parseInt(declarationRequest?.unit?.mogawra_id)}
                onChange={handleChangeMogawra}
                isClearable={true}
                disabled={
                  declarationRequest?.viewMode ||
                  declarationRequest?.isUnitViewMode ||
                  isUnitInSameBuilding
                }
              />
            </div>
            <div className="col-lg-4 col-sm-6">
              <SearchSelectElement
                mb4="mb-4"
                labelHtmlFor="settlement_id"
                labelClassName={`form-label ${stylesRequestData["form-label"]}`}
                labelText="التجمع السكني"
                selectClassName={`${stylesRequestData["form-select"]} form-select`}
                selectID="settlement_id"
                inputId="settlement_id_input"
                name="settlement_id"
                options={generateOptions(settlements)}
                default="أختار التجمع السكني .."
                pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                pText={error_new_user.settlement_id}
                value={parseInt(declarationRequest?.unit?.settlement_id)}
                onChange={handleChangeSettlement}
                isClearable={true}
                disabled={
                  declarationRequest?.viewMode ||
                  declarationRequest?.isUnitViewMode ||
                  isUnitInSameBuilding
                }
              />
            </div>
          </>
        ) : selectedSearchMode === 1 ? (
          <>
            <p className={styles.mapHintInfo}>
              في حال تعذر استخدام الخريطة يرجى تحديد العنوان يدويا مع مراعاة
              ادخال الرقم القومي العقاري إن وجد و سيتم ارسال رسالة لحضراتكم
              لتأكيد بيانات الموقع على الخريطة لاحقا
            </p>
            <div className="col-lg-4 col-sm-6">
              <SearchSelectElement
                mb4="mb-4"
                labelHtmlFor="governorate_id"
                labelClassName={`form-label ${stylesRequestData["form-label"]}`}
                labelText="المحافظة"
                selectClassName={`${stylesRequestData["form-select"]} form-select`}
                selectID="governorate_id"
                inputId="governorate_id_input"
                name="governorate_id"
                options={generateOptions(govs)}
                default="أختار المحافظة.."
                pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                pText={error_new_user.governorate_id}
                value={parseInt(declarationRequest?.unit?.governorate_id)}
                // key={parseInt(declarationRequest?.unit?.governorate_id)}
                onChange={handleChangeGov}
                isClearable={true}
                disabled={
                  declarationRequest?.viewMode ||
                  declarationRequest?.isUnitViewMode ||
                  isUnitInSameBuilding
                }
              />
            </div>
            <div className="col-lg-4 col-sm-6">
              <SearchSelectElement
                mb4="mb-4"
                labelHtmlFor="police_station_id"
                labelClassName={`form-label ${stylesRequestData["form-label"]}`}
                labelText="مركز/ قسم شرطة "
                selectClassName={`${stylesRequestData["form-select"]} form-select`}
                selectID="police_station_id"
                inputId="police_station_id_input"
                name="police_station_id"
                options={generateOptions(policeStations)}
                default="أختار مركز/ قسم شرطة .."
                pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                pText={error_new_user.police_station_id}
                value={parseInt(declarationRequest?.unit?.police_station_id)}
                onChange={handleChangePoliceStation}
                isClearable={true}
                disabled={
                  declarationRequest?.viewMode ||
                  declarationRequest?.isUnitViewMode ||
                  isUnitInSameBuilding
                }
              />
            </div>

            <div className="col-lg-4 col-sm-6">
              <SearchSelectElement
                mb4="mb-4"
                labelHtmlFor="street_id"
                labelClassName={`form-label ${stylesRequestData["form-label"]}`}
                labelText="شارع"
                selectClassName={`${stylesRequestData["form-select"]} form-select`}
                selectID="street_id"
                inputId="street_id_input"
                name="street_id"
                options={generateOptions(streets)}
                default="أختار الشارع .."
                pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                pText={error_new_user.street_id}
                value={parseInt(declarationRequest?.unit?.street_id)}
                onChange={handleChangeStreet}
                isClearable={true}
                disabled={
                  declarationRequest?.viewMode ||
                  declarationRequest?.isUnitViewMode ||
                  isUnitInSameBuilding
                }
              />
            </div>
            <div className="col-lg-4 col-sm-6">
              <SearchSelectElement
                mb4="mb-4"
                labelHtmlFor="settlement_id"
                labelClassName={`form-label ${stylesRequestData["form-label"]}`}
                labelText="التجمع السكني"
                selectClassName={`${stylesRequestData["form-select"]} form-select`}
                selectID="settlement_id"
                inputId="settlement_id_input"
                name="settlement_id"
                options={generateOptions(settlements)}
                default="أختار التجمع السكني .."
                pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                pText={error_new_user.settlement_id}
                value={parseInt(declarationRequest?.unit?.settlement_id)}
                onChange={handleChangeSettlement}
                isClearable={true}
                disabled={
                  declarationRequest?.viewMode ||
                  declarationRequest?.isUnitViewMode ||
                  isUnitInSameBuilding
                }
              />
            </div>
          </>
        ) : (
          <div className="col-12">
            <InputElement
              mb4="mb-4"
              labelHtmlFor="manual_search_address"
              labelClassName={`form-label ${stylesRequestData["form-label"]}`}
              labelText="عنوان العقار"
              inputType="text"
              inputClassName={`${stylesRequestData["form-control"]} form-control`}
              inputID="manual_search_address"
              name="manual_search_address"
              placeholder="ادخل عنوان العقار"
              value={declarationRequest?.unit?.manual_search_address || ""}
              onChange={handleChangeGoogleSearch}
              disabled={
                declarationRequest?.viewMode ||
                declarationRequest?.isUnitViewMode ||
                isUnitInSameBuilding
              }
            />
          </div>
        )}
      </div>

      <div className={`w-100 position-relative  `} style={{ zIndex: "0" }}>
        <enterprise-map-control
          ref={emcRef}
          style={{ width: "100%", height: "100%", display: "block" }}
        ></enterprise-map-control>
      </div>

      {hasValidBuildingProfile ? (
        <div ref={addressRef} className={` ${styles.profileContainer}`}>
          {/* RENIN */}
          <div className="col-12 col-lg-6">
            <InputElement
              mb4="mb-3"
              labelHtmlFor="renin"
              labelClassName={`form-label ${stylesRequestData["form-label"]}`}
              labelText="الرقم القومي العقاري"
              inputType="text"
              inputClassName={`${stylesRequestData["form-control"]} form-control`}
              inputID="renin"
              name="renin"
              value={activeBuildingProfile?.renin || ""}
              disabled
            />
          </div>

          {/* Address Label + Info */}
          <div className={styles.addressHeader}>
            <label className={`form-label ${stylesRequestData["form-label"]}`}>
              عنوان العقار
            </label>
          </div>

          {/* Address Content */}
          <div className={styles.addressDisplay}>
            {buildFullAddressDisplayViewMode(activeBuildingProfile)}
          </div>
          <div className={styles.mapHint}>
            {unitMapError === "" ? (
              <p className={styles.mapHintInfo}>
                يرجى الضغط على زر "حفظ" أعلى الصفحة على اليسار لتأكيد المبنى
                المختار من الخريطة واستكمال البيانات المطلوبة{" "}
              </p>
            ) : (
              <p className={styles.mapHintError}>{unitMapError}</p>
            )}
          </div>
        </div>
      ) : (
        <div className={styles.mapHint}>
          {unitMapError === "" ? (
            <p className={styles.mapHintInfo}>
              لاستدعاء عنوان العقار برجاء الضغط مرتين على العقار المحدد، وفي
              حاله عدم وجود العقار علي الخريطة يرجى اختيار موقع أقرب عقار لحين
              تحديث بيانات الخريطة.
            </p>
          ) : (
            <p className={styles.mapHintError}>{unitMapError}</p>
          )}
        </div>
      )}
    </div>
  );
}

export default IframeMapComponent;
